module.exports = __webpack_public_path__ + "img/download.11b9b644.png";